export default function WiFi() {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_10719_11582)">
                <path d="M8.3 16L5 24H27L23.7 16H8.3Z" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
                <path d="M7 6L8.41666 16" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M25 6L23.5833 16" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M16 4V16" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M5 24V26C5 26.5523 5.44772 27 6 27H26C26.5523 27 27 26.5523 27 26V24"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_10719_11582">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
